/** UI-only: delay before top-level redirect or parent postMessage (BFF does not send this). */
export const REDIRECT_DELAY_SUCCESS_MS = 2000;

export const REDIRECT_DELAY_ERROR_MS = 5000;
